<template>
  <iframe id="chat" class="chat-content" style="position:absolute;height:100%;width:100%;border:0px;padding-top:1px;" v-bind:src="theLoungeUri"></iframe>
</template>
<script>
export default {
  data () {
    return {
      kiwiIrcUri: 'https://kiwiirc.com/client/irc.emp.cx/?&amp;theme=cli#electronic',
      theLoungeUri: 'http://159.203.64.57:9000/#connect'
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/Chat.vue